import { useSelector } from 'react-redux';
import { mailingAddressDataSelector } from '../redux/selectors/mailingAddressDataSelector';

const useMailingAddressData = () => useSelector(mailingAddressDataSelector);

export default useMailingAddressData;
